// 레거시 포맷(`<span data-latex="…">…</span>`)을 사전 정규화 단계에서
// `<math-inline data-latex="…"></math-inline>`로 치환한다. RichText 도입
// 초창기 데이터에 잔존하는 형식이며, MathInline extension의 parseHTML도
// 동일한 매핑(span[data-latex] → math-inline)을 가지고 있다.
// data-latex 값은 원본 attribute escape를 그대로 재투입하므로 downstream
// `decodeHtmlEntities`가 동일 규칙으로 풀어 Temml에 넘긴다.
const LEGACY_SPAN_LATEX =
  /<span\b[^>]*?\bdata-latex="([^"]*)"[^>]*>[\s\S]*?<\/span>/g;

export const normalizeLegacySpanLatex = (text: string): string =>
  text.replace(
    LEGACY_SPAN_LATEX,
    (_, latex) => `<math-inline data-latex="${latex}"></math-inline>`,
  );
